// Gravity Forms custom file browse module
// Inserts a custom label which mimics the 'choose file' button
if ( document.querySelector( '.ginput_container_fileupload' ) ) {

	var displayFilename = function( e ) {

		var filename = '',
			filenameElParent = e.srcElement.parentNode,
			filenameEl = filenameElParent.querySelectorAll( '.selectedfile' )[0];

		// Check if a file has been uploaded
		if ( e.target.value.length > 1 ) {

			filename = e.target.value.split( '\\' ).pop();
			filenameEl.innerText = filename;

		}

	};

	// Find an element matching the Gravity Forms file upload structure
	var gformFileWrap = document.querySelectorAll( '.ginput_container_fileupload' );
	var browseLabel = 'Browse';

	// There might be multiple browse files in a form
	for ( var i = 0; i < gformFileWrap.length; i++ ) {

		// Determine the ID of the file upload input
		var fileUploadEl = gformFileWrap[i].querySelectorAll( 'input[type="file"]' );
		var fileUploadElMulti = gformFileWrap[i].querySelectorAll( '.gform_fileupload_multifile .gform_drop_area input' );

		// Use alternate selector with multi-file upload field.
		if ( fileUploadElMulti.length ) {
			fileUploadEl = fileUploadElMulti[0];
		} else {
			fileUploadEl = fileUploadEl[0];
		}

		// Setup up browse label.
		if ( 'undefined' !== typeof locationMapSettings ) {
			browseLabel = locationMapSettings.browse;
		}

		if ( 'object' === typeof fileUploadEl ) {
			if ( 'undefined' !== typeof fileUploadEl.id ) {
				var fileId = fileUploadEl.id;

				// Create the browse file element
				var browseEl = document.createElement( 'label' );

				browseEl.htmlFor = fileId;
				browseEl.innerText = browseLabel;
				browseEl.classList.add( 'browse' );

				// Single upload selected file element.
				if ( 0 === fileUploadElMulti.length ) {
					// Create a span to hold the name of the selected file
					var selectedFileEl = document.createElement( 'span' );

					selectedFileEl.classList.add( 'selectedfile' );
					selectedFileEl.innerText = '';
					gformFileWrap[i].appendChild( selectedFileEl );
				}

				// Append the Browse Label to the GForm Container
				gformFileWrap[i].appendChild( browseEl );

				// Mirror the value of the chosen file in a neighboring span
				fileUploadEl.addEventListener( 'change', displayFilename );
			}
		}
	}

}
